import { connect } from 'react-redux';
import TemplatesPageComponent from '../components/templates/TemplatesPage';

const mapStateToProps = (state) => ({
  userId: state.catalogReducer?.user?.userId,
});

export default connect(mapStateToProps)(TemplatesPageComponent);
